import Loadable from '@react-loadable/revised';

const LoadableDomainOverview = Loadable({
    loader: () => import('./DomainOverview'),
    loading: () => null
});

export default LoadableDomainOverview;
